import { Pipe, PipeTransform } from '@angular/core';
import { formatNum } from 'src/app/core/utils/text-utils';

@Pipe({
  name: 'formatNum',
  standalone: false,
})
export class FormatNumPipe implements PipeTransform {
  public transform(num?: string, format?: string): string {
    return format ? formatNum(num, format) : (num ?? '');
  }
}
